module.exports = __webpack_public_path__ + "static/media/edit-custom-fields-preview.b755e8f7.png";